import { Link } from 'react-router-dom'

const NotFound = () => {
    return(
        <main className='hero'>
            <h1>Error 404</h1>
            <h2>Página no encontrada</h2>
            <Link to={'/'}>
                Volver
            </Link>
        </main>
    )
}

export default NotFound